import { Directive, Input, ElementRef, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import * as d3 from 'd3';

@Directive({
  selector: '[ctlLineChart]'
})

export class LineChartDirective implements AfterViewInit {

  colors = [];
  duration = 5;

  lineOpacity = '0.25';
  lineOpacityHover = '0.85';
  otherLinesOpacityHover = '0.1';
  lineStroke = '2.5px';
  lineStrokeHover = '2.5px';

  circleOpacity = '0.85';
  circleOpacityOnLineHover = '0.25';
  circleRadius = 3;
  circleRadiusHover = 6;

  @Input('ctlLineChart') opt: any;
  @Input('ctlLineData') data: any[];
  newdata: any;
  private tooltip: any;

    title = 'Multi-Series Line Chart';

    svg: any;
    margin = {top: 20, right: 80, bottom: 30, left: 50};
    padding = {top: 5, right: 5, bottom: 5, left: 5};

    g: any;
    width = 886;
    height = 330;
    x;
    y;
    z;
    line;

    constructor(private el: ElementRef) {
    }

    ngAfterViewInit(): void {
      if (this.data) {
        this.newdata = this.data.map((v) => v.values.map((v) => v.date ))[0];

        this.initChart();
        this.drawAxis();
        if (this.opt.avgline) {
          this.avgLine();
        }
        this.drawPath();
        this.addDot();
      }
    }

    ngOnChanges(changes: SimpleChanges) {
      if (typeof changes['data'] !== 'undefined') {
        // retrieve the quiz variable change info
        const change = changes['data'];
        // only perform the task if the value has been changed
        if (!change.isFirstChange()) {
          // execute the Http request and retrieve the result
          this.newdata = this.data.map((v) => v.values.map((v) => v.date ))[0];
          this.initChart();
          this.drawAxis();
          if (this.opt.avgline) {
            this.avgLine();
          }
          this.drawPath();
          this.addDot();
        }
      }
    }

    private initChart(): void {
      let selector = '.line';
      if (this.opt.selector) {
        selector = this.opt.selector;
      }

      d3.select('#' + selector).select('svg').remove();

      if (this.opt.width) {
        this.width = this.opt.width;
      }

      if (this.opt.height) {
        this.height = this.opt.height;
      }

      if (this.opt.colors) {
        this.colors = this.opt.colors;
      }

      if (this.opt.margin) {
        this.margin.top = this.opt.margin;
        this.margin.bottom = this.opt.margin;
        this.margin.left = this.opt.margin;
        this.margin.right = this.opt.margin;
      }

      if (this.opt.padding) {
        this.padding.top = this.opt.padding;
        this.padding.bottom = this.opt.padding;
        this.padding.left = this.opt.padding;
        this.padding.right = this.opt.margin;
      }

      this.svg = d3.select('#' + selector);

      this.tooltip = d3.select('#' + selector)
        .append('div')
        .attr('class', 'tooltip')
        .style('display', 'none');

      this.g = this.svg.append('svg')
          .attr('width', this.width + this.margin.left + this.margin.right)
          .attr('height', this.height + this.margin.top + this.margin.bottom)
          .append('g')
          .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')')
          .style('stroke', '#f2f2f2');

      this.x = d3.scaleTime().range([0, this.width]);
      this.y = d3.scaleLinear().range([this.height, 0]);
      this.z = d3.scaleOrdinal(this.colors);

      this.line = d3.line()
        .x( (d: any) => this.x(d.date) )
        .y( (d: any) => this.y(d.count) );

      this.x.domain([
        new Date(d3.min(this.newdata, (d: Date) => new Date(d).getTime() - (24 * 3600 * 1000))),
        new Date(d3.max(this.newdata, (d: Date) => new Date(d).getTime() + (24 * 3600 * 1000))),
      ]);

      this.y.domain([
        0, d3.max(this.data, (c: any) => d3.max(c.values, (d: any) => d.count))
      ]);

      this.z.domain(this.data.map((c) => c.id));

      this.g.append('g')
          .attr('class', 'grid')
          .attr('transform', 'translate(padding.left, padding.bottom)')
          .style('stroke-dasharray', ('2,2'))
          .style('stroke', '#181818')
          .style('fill', '#000000')
          .call(d3.axisBottom(this.x)
            .tickSize((this.height))
            .tickFormat(null)
          );

      this.g.append('g')
          .attr('class', 'grid')
          .attr('transform', 'translate(padding.left , padding.top)')
          .style('opacity', '0.9')
          .style('stroke', '#181818')
          .call(d3.axisLeft(this.y)
            .tickSize(-(this.width))
            .tickFormat(null)
      );
    }

    private drawAxis(): void {
        this.g.append('g')

            .attr('class', 'axis axis--x')
            .style('font-family', 'Ericsson Hilda Light')
            .style('font-weight', 'normal')

            .style('text-shadow', 'none')
            .attr('transform', `translate(0, ${this.height})`)
            .call(d3.axisBottom(this.x)
              .tickFormat(null)
              .tickSize(10)

            );

        this.g.append('g')
            .attr('class', 'axis axis--y')
            .style('font-family', 'Ericsson Hilda Light')
            .style('font-weight', 'normal')
            .style('text-shadow', 'none')
            .call(d3.axisLeft(this.y));
    }

    private drawPath(): void {
      const self = this;
      const city = this.g.selectAll('.city')
        .data(this.data)
        .enter().append('g')
        .attr('class', 'city');

      city.append('path')
        .attr('class', 'line')
        .style('opacity', '0.5')
        .attr('d', (d: any) => this.line(d.values) )
        .style('stroke', (d: any) => this.z(d.id) );
    }

    private addDot() {
      const self = this;
      const dot = this.g.selectAll('circle-group')
        .data(self.data)
        .enter()
        .append('g')
        .style('fill', (d, i) => self.z(d.id))
        .selectAll('circle')
        .data(d => d.values).enter()
        .append('g')
        .attr('class', 'circle')
        .on('mouseover', (d) => {
          self.mouseoverD3();
        })
        .on('mousemove', (d) => {
          self.mousemoveD3(d);
        })
        .on('mouseout', (d) => {
          self.mouseoutD3();
        })
        .append('circle')
        .attr('cx', d => self.x(d.date))
        .attr('cy', d => self.y(d.count))
        .attr('r', self.circleRadius)
        .style('opacity', self.circleOpacity)
        .on('mouseover', function(d) {
            d3.select(this)
              .transition()
              .duration(self.duration)
              .attr('r', self.circleRadiusHover);
          })
        .on('mouseout', function(d) {
            d3.select(this)
              .transition()
              .duration(self.duration)
              .attr('r', self.circleRadius);
          });

    }

    private mouseoverD3() {
      this.tooltip
        .style('display', 'inline-block')
        .style('position', 'absolute');
    }

    private mousemoveD3(d) {
      this.tooltip
        .html('<div style="background-color: #ffffff; color: #181818;padding: 5px;">' + d.date + ', ' + d.count + '</div>')
        .style('left', d3.event.pageX + 15 + 'px')
        .style('top', d3.event.pageY + 15 + 'px');
    }

    private mouseoutD3() {
      this.tooltip
        .style('display', 'none');
    }

    private avgLine() {
      const self = this;

      const avg = d3.mean(this.data, (c: any) => d3.mean(c.values, (d: any) => d.count ));

      const avgline = this.g.append('g')
      .attr('class', 'avgline')
      .style('stroke-dasharray', ('8,8'))
      .style('stroke', '#18181')

      // Clinicial cut off line
      avgline.append('line')
        .attr('class', 'avgline')
        .attr('x1', 0)
        .attr('y1', self.y(avg))
        .attr('x2', self.width)
        .attr('y2', self.y(avg));
        }
}
